import { render, staticRenderFns } from "./voteRecords.vue?vue&type=template&id=ca8a28e2&scoped=true&"
import script from "./voteRecords.vue?vue&type=script&lang=js&"
export * from "./voteRecords.vue?vue&type=script&lang=js&"
import style0 from "./voteRecords.vue?vue&type=style&index=0&id=ca8a28e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca8a28e2",
  null
  
)

export default component.exports